import { K8sProvider } from '@cast/shared-types';
import { Cluster } from '@cast/types';

/**
 * Labels for `cluster.providerNamespaceId` by CSP.
 * Inventory API: AWS account ID, Azure subscription ID, GCP project ID.
 */
const PROVIDER_NAMESPACE_LABELS: Partial<Record<K8sProvider, string>> = {
  [K8sProvider.EKS]: 'Account ID',
  [K8sProvider.AKS]: 'Subscription ID',
  [K8sProvider.GKE]: 'Project name',
};

const DEFAULT_PROVIDER_NAMESPACE_LABEL = 'Project name';

export type GetProviderNamespaceLabelArgs = {
  providerType: Cluster['providerType'] | undefined;
};

export const getProviderNamespaceLabel = ({
  providerType,
}: GetProviderNamespaceLabelArgs): string => {
  if (!providerType) {
    return DEFAULT_PROVIDER_NAMESPACE_LABEL;
  }

  return (
    PROVIDER_NAMESPACE_LABELS[providerType] ?? DEFAULT_PROVIDER_NAMESPACE_LABEL
  );
};

export type GetProviderNamespaceIdentifierArgs = {
  providerType: Cluster['providerType'] | undefined;
  providerNamespaceId?: string;
};

/** EKS / AKS / GKE only — matches legacy `getUniqueIdentifier` behavior. */
export const getProviderNamespaceIdentifier = ({
  providerType,
  providerNamespaceId,
}: GetProviderNamespaceIdentifierArgs):
  | { label: string; value: string }
  | undefined => {
  if (!providerType) {
    return undefined;
  }

  const label = PROVIDER_NAMESPACE_LABELS[providerType];
  if (!label) {
    return undefined;
  }

  return {
    label,
    value: providerNamespaceId || '',
  };
};

export type FormatProviderNamespaceChipLabelArgs = {
  providerType: Cluster['providerType'] | undefined;
  providerNamespaceId?: string;
};

export const formatProviderNamespaceChipLabel = ({
  providerType,
  providerNamespaceId,
}: FormatProviderNamespaceChipLabelArgs): string | undefined => {
  if (!providerNamespaceId) {
    return undefined;
  }

  return `${getProviderNamespaceLabel({
    providerType,
  }).toUpperCase()}: ${providerNamespaceId}`;
};
